<res-login (loginCallback)="login()"></res-login>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/login/login.component.ts.LoginComponent.html